import { useMutation } from "@tanstack/react-query";
import { updateMonthlyHours } from "../api/timeEntryApi";

// Actualiza el registro de horas mensual existente (PUT time-entry/update-monthly-hours).
export const useUpdateMonthlyHours = () =>
  useMutation({
    mutationFn: updateMonthlyHours,
  });
